export function compareDate(date1: Date, date2: Date) {
  return (
    date1.getDate() == date2.getDate() &&
    date1.getMonth() == date2.getMonth() &&
    date1.getFullYear() == date2.getFullYear()
  );
}

export function formatDate(date: Date) {
  if (isNaN(date.getTime())) {
    return "Invalid Date";
  }

  let format = localStorage.getItem("dateFormat");

  if (
    format != "MM/DD/YYYY" &&
    format != "DD/MM/YYYY" &&
    format != "YYYY-MM-DD"
  ) {
    const userLang = navigator.language || (navigator as any).userLanguage;
    const dateFormat = userLang.includes("en") ? "MM/DD/YYYY" : "DD/MM/YYYY";
    format = dateFormat;
  }

  return format
    .replace(/YYYY/g, date.getFullYear().toString())
    .replace(/MM/g, (date.getMonth() + 1).toString().padStart(2, "0"))
    .replace(/DD/g, date.getDate().toString().padStart(2, "0"));
}
